import { sprintf } from 'sprintf-js';

import { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { Color } from 'theme/theme';

import { AvatarContainer } from './Avatar.styled';

type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const AVATAR_SIZES = {
  xs: 38,
  sm: 60,
  md: 84,
  lg: 150,
  xl: 192,
};

type Props = {
  border?: Color;
  image: ApiFilestackImageData;
  name: string;
  size: AvatarSize;
};

export function Avatar({ border, image, name, size }: Props) {
  return (
    <AvatarContainer $border={border}>
      <FilestackImage
        data-qa-id="avatar"
        alt={sprintf(getText('%(name)s profile image'), {
          name,
        })}
        data={image}
        width={AVATAR_SIZES[size]}
        height={AVATAR_SIZES[size]}
        round
      />
    </AvatarContainer>
  );
}
